import { createSlice } from "@reduxjs/toolkit";

// 🔹 Load saved cart (if any)
const initialCart = () => {
  const saved = sessionStorage.getItem("cart");
  return saved ? JSON.parse(saved) : [];
};

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: initialCart(),
  },
  reducers: {
    addToCart: (state, action) => {
      const {
        productId,
        item,
        mrp,
        imageUrl,
        partner,
        selectedQty,
        selectedUnit, // ✅ unified for both main & sub units
        price,
      } = action.payload;

      // ✅ Identify item uniquely by product + selected unit label
      const existing = state.items.find(
        (i) =>
          i.productId === productId &&
          (i.selectedUnit?.label || i.selectedUnit?.subUnit || "Main Unit") ===
            (selectedUnit?.label || "Main Unit")
      );

      if (existing) {
        if (selectedQty > 0) {
          existing.qty = selectedQty; // update existing qty
        } else {
          // remove item if qty = 0
          state.items = state.items.filter(
            (i) =>
              !(
                i.productId === productId &&
                (i.selectedUnit?.label || i.selectedUnit?.subUnit || "Main Unit") ===
                  (selectedUnit?.label || "Main Unit")
              )
          );
        }
      } else if (selectedQty > 0) {
        // ✅ Add new item
        state.items.push({
          productId,
          name: item,
          mrp,
          imageUrl,
          partner,
          qty: selectedQty,
          selectedUnit,
          price,
        });
      }

      // ✅ Persist to sessionStorage
      sessionStorage.setItem("cart", JSON.stringify(state.items));
    },

    clearCart: (state) => {
      state.items = [];
      sessionStorage.removeItem("cart");
    },
  },
});

export const { addToCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
